export const cacheDateTimeStamp = new Map();
export const cacheDateStamp = new Map();
export const cacheDateMomentStamp = new Map();
export const cacheDateHourStamp = new Map();

export const cacheFileSizeMap = new Map();
export const cacheGetCalendarRenderTime = new Map();

export const cacheSearchMenuItems: Record<string, any[]> = {};
